import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { TOAST_EVENT, ToastDetail } from '../utils/apiError';

const COLORS: Record<string, string> = {
  error: '#DC2626',
  warning: '#D97706',
  success: '#059669',
  info: '#2563EB',
};

/** Toast global — dipicu `showToast()` / `notifyApiError()` dari mana saja (termasuk axiosInstance). */
export const GlobalToast: React.FC = () => {
  const { t } = useLanguage();
  const e = (t as any).apiErrors || {};
  const [toast, setToast] = useState<ToastDetail | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const onToast = (ev: Event) => {
      const detail = (ev as CustomEvent<ToastDetail>).detail;
      setToast(detail);
      if (timer.current) clearTimeout(timer.current);
      // Pesan timeout lebih panjang (berisi instruksi cek data) → tampil lebih lama
      timer.current = setTimeout(() => setToast(null), detail.kind === 'timeout' ? 8000 : 5000);
    };
    window.addEventListener(TOAST_EVENT, onToast);
    return () => {
      window.removeEventListener(TOAST_EVENT, onToast);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  if (!toast) return null;
  const text =
    toast.message ||
    (toast.kind === 'timeout' ? e.timeout
      : toast.kind === 'network' ? e.network
      : toast.kind === 'tooLarge' ? e.tooLarge
      : e.generic) ||
    'Error';

  return (
    <div
      role="alert"
      onClick={() => setToast(null)}
      style={{
        position: 'fixed', left: 16, right: 16, bottom: 'calc(80px + env(safe-area-inset-bottom, 0px))',
        zIndex: 100000, display: 'flex', justifyContent: 'center', pointerEvents: 'none',
      }}
    >
      <div style={{
        pointerEvents: 'auto', maxWidth: 480, width: '100%', background: COLORS[toast.type || 'error'],
        color: '#fff', borderRadius: 12, padding: '12px 16px', fontSize: 14, lineHeight: 1.4,
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)', whiteSpace: 'pre-line',
      }}>
        {text}
      </div>
    </div>
  );
};
